import { withInstall, withNoopInstall } from '@bigin/utils'
import Carousel from './src/carousel.vue'
import CarouselItem from './src/carousel-item.vue'

export const BCarousel = withInstall(Carousel, {
  CarouselItem,
})

export default BCarousel

export const BCarouselItem = withNoopInstall(CarouselItem)

export * from './src/carousel'
export * from './src/carousel-item'
